import { useState } from "react";

function SearchFilter({
  cars,
  setFiltered
}) {

  const [search, setSearch] =
    useState("");

  const handleSearch = (e) => {

    const value = e.target.value;

    setSearch(value);

    const filtered =
      cars.filter((car) =>
        car.name
          .toLowerCase()
          .includes(
            value.toLowerCase()
          )
      );

    setFiltered(filtered);
  };

  return (
    <div className="search-box">

      <input
        type="text"
        placeholder="Search Cars..."
        value={search}
        onChange={handleSearch}
      />

    </div>
  );
}

export default SearchFilter;